import { useWindowSize } from "@uidotdev/usehooks";
import "./GuidesAgentsImmos.css";
import React, { useContext, useEffect, useState } from "react";
import ThumbnailsGroup from "../../../components/organisms/thumbnailsGroup/ThumbnailsGroup";
import FilledButton from "../../../components/molecules/buttons/filledButton/FilledButton";
import Thumbnail from "../../../components/molecules/thumbnail/Thumbnail";
import AppContext from "../../../context/AppContext";
import { getPrettyText } from "../../../utils/Utils";
import { fetchAllGuideAgentsImmosApi } from "../../../api/ToolsApi";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/organisms/loader/Loader";

function GuidesAgentsImmos() {
  const [articles, setArticles] = useState([]);

  const { _, width } = useWindowSize();
  const { setBannerConfig } = useContext(AppContext);
  const navigate = useNavigate();
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  useEffect(() => {
    fetchArticles();

    setBannerConfig({
      title: <>Nos guides pour agents immos</>,
      subtitle: <>Le secret de la réussite dans 12 guides du terrain</>,
    });
  }, []);

  async function fetchArticles() {
    setIsLoaderVisible(true);

    try {
      const data = (await fetchAllGuideAgentsImmosApi()).data;
      data.map((article, index) => {
        data[index] = {
          title: getPrettyText(article.title),
          picture: `${process.env.REACT_APP_API_URL}/assets/GuidesAgentsImmos/${article.newsletter_url}/miniature/${article.image_path}`,
          linkText: "Lire le guide",
          article_url: article.newsletter_url,
        };
      });

      setArticles(data);
    } catch (error) {
      navigate("/404");
    } finally {
      setIsLoaderVisible(false);
    }
  }

  return (
    <>
      <section className='container page-container'>
        {isLoaderVisible ? (
          <Loader preventScrolling={false} visible={isLoaderVisible} className='practical-tools-loader' />
        ) : width > 576 && articles.length ? (
          <ThumbnailsGroup data={articles} />
        ) : (
          <>
            <div className='mobile-thumbnails-col'>
              {articles.map((article, key) => {
                return <Thumbnail {...article} link={article.article_url} key={key} />;
              })}
            </div>
          </>
        )}
        <FilledButton className='mid-page-button' padding='10px 25px' to='/debut-parcours'>
          Je démarre une estimation
        </FilledButton>
      </section>
    </>
  );
}

export default GuidesAgentsImmos;
